import moment from 'moment-timezone';
import { RelativeDateRangeUnit } from '@/datetime/relativeDateRange.types';
import type { DateRangePreset, QuickDateRange } from '@/datetime/relativeDateRange.types';

/** The range a new or cleared Impact Report uses: the year leading up to now. */
export const DEFAULT_IMPACT_REPORT_DATE_SELECTION: DateRangePreset = Object.freeze({
  kind: 'relative',
  relativeDateRangeSelection: Object.freeze({ amount: 1, unit: RelativeDateRangeUnit.YEAR }),
});

/** Impact Report quick picks, in display order. */
export const IMPACT_REPORT_QUICK_DATE_RANGES: readonly QuickDateRange[] = [
  {
    id: 'todayQuickRange',
    label: 'IMPACT_REPORT.DATE_RANGE_OPTIONS.TODAY',
    preset: { kind: 'calendar', calendarRange: 'today' },
  },
  {
    id: 'lastMonthQuickRange',
    label: 'IMPACT_REPORT.DATE_RANGE_OPTIONS.LAST_MONTH',
    preset: { kind: 'relative', relativeDateRangeSelection: { amount: 1, unit: RelativeDateRangeUnit.MONTH } },
  },
  {
    id: 'lastQuarterQuickRange',
    label: 'IMPACT_REPORT.DATE_RANGE_OPTIONS.LAST_QUARTER',
    preset: { kind: 'relative', relativeDateRangeSelection: { amount: 3, unit: RelativeDateRangeUnit.MONTH } },
  },
  {
    id: 'lastYearQuickRange',
    label: 'IMPACT_REPORT.DATE_RANGE_OPTIONS.LAST_YEAR',
    preset: { kind: 'relative', relativeDateRangeSelection: { amount: 1, unit: RelativeDateRangeUnit.YEAR } },
  },
  {
    id: 'yearToDateQuickRange',
    label: 'IMPACT_REPORT.DATE_RANGE_OPTIONS.YEAR_TO_DATE',
    preset: { kind: 'calendar', calendarRange: 'yearToDate' },
  },
];

export function getDisplayDate(date: string | undefined, timezone: { name: string }) {
  return moment(date).isValid() ? moment(date).tz(timezone.name).format('l') : '';
}

export function getCalendarRangeDateLabel(
  startDate: string | undefined,
  endDate: string | undefined,
  timezone: { name: string },
) {
  return `${getDisplayDate(startDate, timezone)} - ${getDisplayDate(endDate, timezone)}`;
}
